// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"48265c91","219":"ae357de0","278":"157cb1ac","706":"24017cf6","761":"e37b4254","917":"e17d03e4","963":"7b39fdf4"}[chunkId] + ".js";
};